import { BookingDTO, TentativeBookingDTO } from "../../apiclient/ApiDtos";

export class BookingConfirmationFsmContext {
    constructor(
        public readonly tenativeBooking : TentativeBookingDTO,
        public readonly booking: BookingDTO | null = null,
        public readonly errorMessage: string | null = null
    ) {}        
}
